// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yz8E","icon":"styles_icon__AujgJ"};